export default __webpack_public_path__ + "static/media/agra2.351030df.jpg";